function getQueryObj(search = window.location.search) {
  const values = search.split('?')
  if (values && values.length && values[1]) {
    const value = decodeURI(values[1])
    return value.split('&').reduce((params, keyValue) => {
      return Object.assign(params, {
        [keyValue.split('=')[0]]: keyValue.split('=')[1] || '',
      })
    }, {})
  }
  return {}
}
export { getQueryObj }
